// Generated by script, don't edit it please.
import createSvgIcon from '../createSvgIcon';
import WechatSvg from '@rsuite/icon-font/lib/platform/Wechat';
var Wechat = createSvgIcon({
  as: WechatSvg,
  ariaLabel: 'wechat',
  category: 'platform',
  displayName: 'Wechat'
});
export default Wechat;